import Papa from "papaparse";

import { expand, flatten } from "./f_it";

export default class CsvService {
  decode<Result extends object = object>(csv: string | null): Result[] {
    if (csv) {
      const options: Papa.ParseConfig = {
        delimiter: ",",
        header: true,
        trimHeaders: true,
        skipEmptyLines: true,
      };
      const result = Papa.parse(csv, { ...options });
      if (result.errors.length) {
        throw new Error(JSON.stringify(result.errors));
      }
      const { data } = result;
      const entries = data.map((entry) =>
        Object.entries(entry).reduce<Record<string, unknown>>(
          (result, [key, value]) => {
            result[key] = value === "" ? null : value;
            return result;
          },
          {},
        ),
      );
      return entries.map((item) => expand(item) as Result);
    }
    return [];
  }

  encode(data?: ReadonlyArray<object>, keys?: string[]): string {
    if (!data?.length) return "";

    const entries = data.map(flatten);
    const fields = keys ?? Object.keys(entries[0] ?? {});

    const body = entries.map((entry) => fields.map((key) => entry[key] ?? ""));

    return Papa.unparse({ fields, data: body });
  }
}
